import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TransformYourSpace from "./sections/TransformYourSpace";
import InsuranceClaimBanner from "./sections/InsuranceClaimBanner";
import TheVectrPhilosophy from "./sections/TheVectrPhilosophy";
import QualitySeals from "./sections/QualitySeals";
import WhyHabeshaPastry from "./sections/WhyHabeshaPastry";
import ReadyToScale from "./sections/ReadyToScale";
import CreatorTestimonials from "./sections/CreatorTestimonials";
import ExploreOurPlayZones from "./sections/ExploreOurPlayZones";
import StrategicAlliances from "./sections/StrategicAlliances";
import VidaEnComunidad from "./sections/VidaEnComunidad";
import ConnectWithUs from "./sections/ConnectWithUs";
import FooterAndLegal from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="pt-0 bg-foreground">
      <Header />
      <TransformYourSpace />
      <InsuranceClaimBanner />
      <TheVectrPhilosophy />
      <QualitySeals />
      <WhyHabeshaPastry />
      <ReadyToScale />
      <CreatorTestimonials />
      <ExploreOurPlayZones />
      <StrategicAlliances />
      <VidaEnComunidad />
      <ConnectWithUs />
      <FooterAndLegal />
    </div>;
}